/**
 * Datas de instantes (timestamps) na hora de Brasília.
 *
 * 🚨 `iso.slice(0, 10)` pega o dia em UTC: um pagamento feito na quinta às 21:30 de Brasília
 * (00:30 de sexta em UTC) aparecia como "Pago sex". O dia mostrado é SEMPRE o de Brasília.
 */

const FUSO = 'America/Sao_Paulo';

/** "2026-09-26T02:30:00Z" → "2026-09-25" (o dia em Brasília). Texto inválido volta como veio. */
export function diaEmBrasilia(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso.slice(0, 10);
  return d.toLocaleDateString('sv-SE', { timeZone: FUSO });
}

/** "2026-09-26T02:30:00Z" → "25/09" (dia/mês em Brasília). */
export function diaCurtoEmBrasilia(iso: string): string {
  return diaEmBrasilia(iso).split('-').reverse().slice(0, 2).join('/');
}
